<template>
  <div class="animated fadeIn">
    <CustomerRecordModal EntityType="Order">
      <div slot="header"></div>
      <div slot="details">
        <!-- <div>{{ mySelected.Title }}</div>
              <div>{{ mySelected.Email1 }}</div> -->
      </div>
      <span slot="entityType"></span>
    </CustomerRecordModal>
    <!-- <b-row>
      <b-col lg="6">
        <b-card>
          <h3 class="text-shoppingCartGray">
            {{ campaign.campaign_roi.CampaignStatHeader.Dealership.Name }}
          </h3>

          <h5>
            {{ campaign.campaign_roi.CampaignStatHeader.Dealership.Address1 }}
            {{ campaign.campaign_roi.CampaignStatHeader.Dealership.Address2 }}
          </h5>
          <h5>
            {{ campaign.campaign_roi.CampaignStatHeader.Dealership.City }}
            {{ campaign.campaign_roi.CampaignStatHeader.Dealership.State }}
            {{ campaign.campaign_roi.CampaignStatHeader.Dealership.PostalCode }}
          </h5>
        </b-card>
      </b-col>
      <b-col lg="6">
        <b-card>
          <h3 class="text-shoppingCartGray">
            PO # {{ campaign.campaign_roi.CampaignStatHeader.PONumber }}
          </h3>

          <h5>
            {{ campaign.campaign_roi.CampaignStatHeader.campaign_name }}
          </h5>
          <h5>
            Broadcast Date:
            {{ campaign.campaign_roi.CampaignStatHeader.broadcast_date }}
          </h5>
        </b-card>
      </b-col>
    </b-row> -->
    <b-row class="mb-4">
      <b-col lg="6">
        <!-- <b-card>
          <h3 class="text-shoppingCartGray">
            {{ campaign.campaign_report.CampaignHeader.Dealership.Name }}
          </h3>

          <h5>
            {{ campaign.campaign_report.CampaignHeader.Dealership.Address1 }}
            {{ campaign.campaign_report.CampaignHeader.Dealership.Address2 }}
          </h5>
          <h5>
            {{ campaign.campaign_report.CampaignHeader.Dealership.City }}
            {{ campaign.campaign_report.CampaignHeader.Dealership.State }}
            {{ campaign.campaign_report.CampaignHeader.Dealership.PostalCode }}
          </h5>
        </b-card> -->

        <div class="return-address">
          <p class="company-name">
            {{ campaign.campaign_report.CampaignHeader.Dealership.Name }}
          </p>
          <p class="address-line">
            {{ campaign.campaign_report.CampaignHeader.Dealership.Address1 }}
            {{ campaign.campaign_report.CampaignHeader.Dealership.Address2 }}
          </p>
          <p class="address-line">
            {{ campaign.campaign_report.CampaignHeader.Dealership.City }},
            {{ campaign.campaign_report.CampaignHeader.Dealership.State }}
            {{ campaign.campaign_report.CampaignHeader.Dealership.PostalCode }}
          </p>
        </div>
      </b-col>
      <b-col lg="6">
        <div class="return-address">
          <p class="company-name">
            PO # {{ campaign.campaign_report.CampaignHeader.PONumber }}
          </p>

          <p class="address-line">
            {{ campaign.campaign_report.CampaignHeader.campaign_name }}
          </p>
          <p class="address-line">
            Broadcast Date:
            {{ campaign.campaign_report.CampaignHeader.broadcast_date }}
          </p>
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col lg="3">
        <b-button variant="link" @click="loadOtherReport(1)"
          ><h3 class="mb-4">
            Activity & Analytics
          </h3></b-button
        >
      </b-col>
      <b-col lg="3">
        <b-button variant="link" disabled
          ><h3 class="mb-4">
            Performance & ROI
          </h3></b-button
        >
      </b-col>
      <b-col lg="3">
        <b-button variant="link" @click="loadOtherReport(3)"
          ><h3 class="mb-4">
            Summary & Charts
          </h3></b-button
        >
      </b-col>
    </b-row>
    <b-row class="mt-4 mb-4">
      <b-col lg="8">
        <b-form-radio-group
          class="mr-3"
          id="radiosBtn"
          buttons
          button-variant="outline-primary"
          v-model="filterStatus"
          name="radiosBtn"
        >
          <b-form-radio
            class="mx-0 standardizedLongWidth"
            style="cursor: pointer;"
            value="sales"
            >Sales Only</b-form-radio
          >
          <b-form-radio
            class="mx-0 standardizedLongWidth"
            style="cursor: pointer;"
            value="service"
            >Service Only</b-form-radio
          >
          <b-form-radio
            class="mx-0 standardizedLongWidth"
            style="cursor: pointer;"
            value="all"
            >Show All</b-form-radio
          >
        </b-form-radio-group>
      </b-col>
      <b-col v-show="campaign.is_report_loading" sm="4" class="localBold mt-1"
        ><i class="fa fa-refresh fa-spin mr-2"></i>Generating Report</b-col
      >
    </b-row>
    <b-row class="mt-4">
      <b-col lg="4">
        <b-card>
          <b-row>
            <b-col lg="12">
              <h3>General</h3>
              <b-row class="mt-2 my-other-alternating-row-color">
                <b-col lg="6">
                  <h5>Investment</h5>
                </b-col>
                <b-col lg="6">
                  <h5>
                    {{
                      as_dollar(
                        campaign.campaign_roi.CampaignStatHeader.Investment
                      )
                    }}
                  </h5>
                </b-col>
              </b-row>
              <b-row class="my-alternating-row-color">
                <b-col lg="6">
                  <h5>Sales Generated</h5>
                </b-col>
                <b-col lg="6">
                  <h5>
                    {{ campaign.campaign_roi.SalesCount }}
                  </h5>
                </b-col>
              </b-row>
              <b-row class="my-other-alternating-row-color">
                <b-col lg="6">
                  <h5>ROs Generated</h5>
                </b-col>
                <b-col lg="6">
                  <h5>
                    {{ campaign.campaign_roi.ROCount }}
                  </h5>
                </b-col>
              </b-row>
              <b-row class="my-alternating-row-color">
                <b-col lg="6">
                  <h5>Cost Veh Sold</h5>
                </b-col>
                <b-col lg="6">
                  <h5>
                    {{ as_dollar(campaign.campaign_roi.CostPerSale) }}
                  </h5>
                </b-col>
              </b-row>
            </b-col>
            <b-col lg="6"> </b-col>
          </b-row>
        </b-card>
      </b-col>
      <b-col lg="4">
        <b-card>
          <b-row>
            <b-col lg="12">
              <h3>Revenue</h3>
              <b-row class="mt-2 my-other-alternating-row-color">
                <b-col lg="6">
                  <h5>Sales</h5>
                </b-col>
                <b-col lg="6">
                  <h5>
                    {{ as_dollar(campaign.campaign_roi.SalesRevenue) }}
                  </h5>
                </b-col>
              </b-row>
              <b-row class="my-alternating-row-color">
                <b-col lg="6">
                  <h5>Service</h5>
                </b-col>
                <b-col lg="6">
                  <h5>
                    {{ as_dollar(campaign.campaign_roi.ServiceRevenue) }}
                  </h5>
                </b-col>
              </b-row>
              <b-row class="my-other-alternating-row-color">
                <b-col lg="6">
                  <h5>Total</h5>
                </b-col>
                <b-col lg="6">
                  <h5>
                    {{ as_dollar(campaign.campaign_roi.TotalRevenue) }}
                  </h5>
                </b-col>
              </b-row>
              <b-row class="my-alternating-row-color">
                <b-col lg="6">
                  <h5>&nbsp;</h5>
                </b-col>
                <b-col lg="6">
                  <h5>
                    &nbsp;
                  </h5>
                </b-col>
              </b-row>
            </b-col>
            <b-col lg="6"> </b-col>
          </b-row>
        </b-card>
      </b-col>
      <b-col lg="4" v-if="showSales">
        <b-card>
          <b-row>
            <b-col lg="12">
              <h3>Vehicle Sales</h3>
              <b-row class="mt-2 my-other-alternating-row-color">
                <b-col lg="6">
                  <h5>New Customers</h5>
                </b-col>
                <b-col lg="6">
                  <h5>
                    {{ as_dollar(campaign.campaign_roi.ConquestSalesRevenue) }}
                  </h5>
                </b-col>
              </b-row>
              <b-row class="my-alternating-row-color">
                <b-col lg="6">
                  <h5>Repeat Customers</h5>
                </b-col>
                <b-col lg="6">
                  <h5>
                    {{
                      as_dollar(
                        campaign.campaign_roi.SalesRevenue -
                          campaign.campaign_roi.ConquestSalesRevenue
                      )
                    }}
                  </h5>
                </b-col>
              </b-row>
              <b-row class="my-other-alternating-row-color">
                <b-col lg="6">
                  <h5>Total Sales</h5>
                </b-col>
                <b-col lg="6">
                  <h5>
                    {{ as_dollar(campaign.campaign_roi.SalesRevenue) }}
                  </h5>
                </b-col>
              </b-row>
              <b-row class="my-alternating-row-color">
                <b-col lg="6">
                  <h5>Sales ROI</h5>
                </b-col>
                <b-col lg="6">
                  <h5>
                    {{
                      as_dollar(
                        campaign.campaign_roi.SalesRevenue /
                          campaign.campaign_roi.CampaignStatHeader.Investment
                      )
                    }}
                    : $1.00
                  </h5>
                </b-col>
              </b-row>
            </b-col>
            <b-col lg="6"> </b-col>
          </b-row>
        </b-card>
      </b-col>
      <b-col lg="4" v-if="showService">
        <b-card>
          <b-row>
            <b-col lg="12">
              <h3>Service</h3>
              <b-row class="mt-2 my-other-alternating-row-color">
                <b-col lg="6">
                  <h5>New Customers</h5>
                </b-col>
                <b-col lg="6">
                  <h5>
                    {{
                      as_dollar(campaign.campaign_roi.ConquestServiceRevenue)
                    }}
                  </h5>
                </b-col>
              </b-row>
              <b-row class="my-alternating-row-color">
                <b-col lg="6">
                  <h5>Repeat Customers</h5>
                </b-col>
                <b-col lg="6">
                  <h5>
                    {{
                      as_dollar(
                        campaign.campaign_roi.ServiceRevenue -
                          campaign.campaign_roi.ConquestServiceRevenue
                      )
                    }}
                  </h5>
                </b-col>
              </b-row>
              <b-row class="my-other-alternating-row-color">
                <b-col lg="6">
                  <h5>Total Service</h5>
                </b-col>
                <b-col lg="6">
                  <h5>
                    {{ as_dollar(campaign.campaign_roi.ServiceRevenue) }}
                  </h5>
                </b-col>
              </b-row>
              <b-row class="my-alternating-row-color">
                <b-col lg="6">
                  <h5>Service ROI</h5>
                </b-col>
                <b-col lg="6">
                  <h5>
                    {{
                      as_dollar(
                        campaign.campaign_roi.ServiceRevenue /
                          campaign.campaign_roi.CampaignStatHeader.Investment
                      )
                    }}
                    : $1.00
                  </h5>
                </b-col>
              </b-row>
            </b-col>
            <b-col lg="6"> </b-col>
          </b-row>
        </b-card>
      </b-col>
      <b-col lg="4" v-if="showService">
        <b-card>
          <b-row>
            <b-col lg="12">
              <h3>Conquest</h3>
              <b-row class="mt-2 my-other-alternating-row-color">
                <b-col lg="6">
                  <h5>Sales / ROs</h5>
                </b-col>
                <b-col lg="6">
                  <h5>
                    {{ campaign.campaign_roi.ConquestSalesCount }} /
                    {{ campaign.campaign_roi.ConquestROCount }}
                  </h5>
                </b-col>
              </b-row>
              <b-row class="my-alternating-row-color">
                <b-col lg="6">
                  <h5>Sales Revenue</h5>
                </b-col>
                <b-col lg="6">
                  <h5>
                    {{ as_dollar(campaign.campaign_roi.ConquestSalesRevenue) }}
                  </h5>
                </b-col>
              </b-row>
              <b-row class="my-other-alternating-row-color">
                <b-col lg="6">
                  <h5>Service Revenue</h5>
                </b-col>
                <b-col lg="6">
                  <h5>
                    {{
                      as_dollar(campaign.campaign_roi.ConquestServiceRevenue)
                    }}
                  </h5>
                </b-col>
              </b-row>
              <b-row class="my-alternating-row-color">
                <b-col lg="6">
                  <h5>Total Revenue</h5>
                </b-col>
                <b-col lg="6">
                  <h5>
                    {{ as_dollar(campaign.campaign_roi.ConquestRevenue) }}
                  </h5>
                </b-col>
              </b-row>
            </b-col>
            <b-col lg="6"> </b-col>
          </b-row>
        </b-card>
      </b-col>
      <b-col lg="4" v-if="showService">
        <b-card>
          <b-row>
            <b-col lg="12">
              <h3>Lost Soul</h3>
              <b-row class="mt-2 my-other-alternating-row-color">
                <b-col lg="6">
                  <h5>ROs Generated</h5>
                </b-col>
                <b-col lg="6">
                  <h5>
                    {{ campaign.campaign_roi.LostSoulROCount }}
                  </h5>
                </b-col>
              </b-row>
              <b-row class="my-alternating-row-color">
                <b-col lg="6">
                  <h5>Service Revenue</h5>
                </b-col>
                <b-col lg="6">
                  <h5>
                    {{
                      as_dollar(campaign.campaign_roi.LostSoulServiceRevenue)
                    }}
                  </h5>
                </b-col>
              </b-row>
              <b-row class="my-other-alternating-row-color">
                <b-col lg="6">
                  <h5>&nbsp;</h5>
                </b-col>
                <b-col lg="6">
                  <h5>
                    &nbsp;
                  </h5>
                </b-col>
              </b-row>
              <b-row class="my-alternating-row-color">
                <b-col lg="6">
                  <h5>&nbsp;</h5>
                </b-col>
                <b-col lg="6">
                  <h5>
                    &nbsp;
                  </h5>
                </b-col>
              </b-row>
            </b-col>
            <b-col lg="6"> </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
    <b-row class="mt-4">
      <b-col lg="8">
        <b-form-group>
          <b-input-group>
            <b-form-input
              type="text"
              placeholder="Search"
              @keyup="filterList"
              v-model="searchString"
            />

            <b-input-group-append>
              <b-input-group-text>
                <i
                  class="fa fa-times appendIcon clickIcon"
                  @click="resetSearch"
                ></i>
              </b-input-group-text>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </b-col>
      <b-col lg="4">
        <!-- <table>
          <tr class="table-success">
            <td>
              Conquest
            </td>
          </tr>
        </table> -->
        <b-form-group>
          <b-input-group>
            <b-input-group-prepend>
              <b-input-group-text
                style="text-align: center; background-color: #FFF; border-color: #FFF; color: #333; font-weight: bolder;"
                >Color Legend</b-input-group-text
              >
            </b-input-group-prepend>
            <b-form-input
              type="text"
              value="Conquest"
              disabled
              style="text-align: center; background-color: rgb(205, 237, 216); border-color: rgb(162, 221, 183); color: #000;"
            />
            <b-form-input
              type="text"
              value="Lost Soul"
              disabled
              style="text-align: center; background-color: rgb(255, 238, 186); border-color: rgb(255, 223, 126); color: #000;"
            />
          </b-input-group>
        </b-form-group>
      </b-col>
    </b-row>
    <h2 v-if="showSales">Vehicle Sales</h2>
    <b-row>
      <b-col sm="12">
        <b-table
          @row-clicked="myRowClickHandler"
          v-if="showSales"
          :items="filteredObjects"
          :fields="fields"
          :tbody-tr-class="rowClass"
          hover
          small
          fixed
          caption
          selectable
          select-mode="single"
          responsive="sm"
          selectedVariant="success"
          :current-page="currentPage"
          :per-page="perPage"
        >
          <!-- <template slot="Functions" slot-scope="data">
            <i
              v-b-tooltip
              title="Delete"
              class="fa fa-trash-o"
              v-b-modal.modal-2
              @click="SetItemToDelete(data.item)"
            ></i>
          </template> -->
        </b-table>

        <nav v-show="isNavVisible">
          <b-pagination
            :per-page="perPage"
            :total-rows="totalRowsFiltered"
            v-model="currentPage"
            prev-text="Prev"
            next-text="Next"
            hide-goto-end-buttons
          />
        </nav>
      </b-col>
    </b-row>
    <hr v-if="showService && showSales" />
    <hr v-if="showService && showSales" />
    <hr v-if="showService && showSales" />
    <h2 v-if="showService">Repair Orders</h2>
    <b-row>
      <b-col sm="12">
        <b-table
          v-if="showService"
          @row-clicked="myRowClickHandler"
          :items="filteredObjectsService"
          :fields="fieldsService"
          :tbody-tr-class="rowClass"
          hover
          small
          fixed
          caption
          selectable
          select-mode="single"
          responsive="sm"
          selectedVariant="success"
          :current-page="currentPageService"
          :per-page="perPage"
        >
          <!-- <template slot="Functions" slot-scope="data">
            <i
              v-b-tooltip
              title="Delete"
              class="fa fa-trash-o"
              v-b-modal.modal-2
              @click="SetItemToDelete(data.item)"
            ></i>
          </template> -->
        </b-table>

        <nav v-show="isNavVisible2">
          <b-pagination
            :per-page="perPage"
            :total-rows="totalRowsServiceFiltered"
            v-model="currentPageService"
            prev-text="Prev"
            next-text="Next"
            hide-goto-end-buttons
          />
        </nav>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import cTable from "@/views/base/Table.vue";
import { CoolSelect } from "vue-cool-select";
import CustomerRecordModal from "@/views/campaigns/CustomerRecordModal.vue";

export default {
  name: "CampaignROI",
  data() {
    return {
      fields: [
        {
          key: "FullName",
          label: "Name",
          sortable: true,
          thStyle: "width: 20%;",
          thClass: "ellipse_cell",
          tdClass: "ellipse_cell"
        },
        {
          key: "DateSold",
          label: "Sale Date",
          sortable: false,
          thStyle: "width: 10%;",
          thClass: "ellipse_cell",
          tdClass: "ellipse_cell"
        },
        {
          key: "NewUsed",
          label: "New/Used",
          sortable: true,
          thStyle: "width: 10%;",
          thClass: "ellipse_cell",
          tdClass: "ellipse_cell"
        },
        {
          key: "VIN",
          label: "VIN",
          sortable: true,
          thStyle: "width: 20%;",
          thClass: "ellipse_cell",
          tdClass: "ellipse_cell"
        },
        {
          key: "VehicleYear",
          label: "Year",
          sortable: true,
          thStyle: "width: 10%;",
          thClass: "ellipse_cell",
          tdClass: "ellipse_cell"
        },
        {
          key: "VehicleMake",
          label: "Make",
          sortable: true,
          thStyle: "width: 10%;",
          thClass: "ellipse_cell",
          tdClass: "ellipse_cell"
        },
        {
          key: "VehicleModel",
          label: "Model",
          sortable: true,
          thStyle: "width: 10%;",
          thClass: "ellipse_cell",
          tdClass: "ellipse_cell"
        },
        {
          key: "TotalProfit",
          label: "Revenue",
          sortable: true,
          thStyle: "width: 10%;",
          thClass: "ellipse_cell",
          tdClass: "ellipse_cell"
        },
        {
          key: "PreviousVisitDate",
          label: "Last Visit",
          sortable: true,
          thStyle: "width: 10%;",
          thClass: "ellipse_cell",
          tdClass: "ellipse_cell"
        }
      ],
      fieldsService: [
        // {
        //   key: "Functions",
        //   label: "",
        //   sortable: false,
        //   thStyle: "width: 5%;"
        // },
        {
          key: "FullName",
          label: "Name",
          sortable: true,
          thStyle: "width: 20%;",
          thClass: "ellipse_cell",
          tdClass: "ellipse_cell"
        },
        {
          key: "ROCloseDate",
          label: "Date",
          sortable: false,
          thStyle: "width: 10%;",
          thClass: "ellipse_cell",
          tdClass: "ellipse_cell"
        },
        // {
        //   key: "ROCloseDate",
        //   label: "Date",
        //   sortable: true,
        //   formatter: "formatDateRow",
        //   thStyle: "width: 10%;"
        // },
        {
          key: "VIN",
          label: "VIN",
          sortable: true,
          thStyle: "width: 20%;",
          thClass: "ellipse_cell",
          tdClass: "ellipse_cell"
        },
        {
          key: "VehicleYear",
          label: "Year",
          sortable: true,
          thStyle: "width: 10%;",
          thClass: "ellipse_cell",
          tdClass: "ellipse_cell"
        },
        {
          key: "VehicleMake",
          label: "Make",
          sortable: true,
          thStyle: "width: 10%;",
          thClass: "ellipse_cell",
          tdClass: "ellipse_cell"
        },
        {
          key: "VehicleModel",
          label: "Model",
          sortable: true,
          thStyle: "width: 10%;",
          thClass: "ellipse_cell",
          tdClass: "ellipse_cell"
        },
        {
          key: "TotalSale",
          label: "Revenue",
          sortable: true,
          thStyle: "width: 10%;",
          thClass: "ellipse_cell",
          tdClass: "ellipse_cell"
        },
        {
          key: "PreviousVisitDate",
          label: "Last Visit",
          sortable: true,
          thStyle: "width: 10%;",
          thClass: "ellipse_cell",
          tdClass: "ellipse_cell"
        }
      ],
      mySelected: {},
      mySelectedService: {},
      currentPage: 1,
      currentPageService: 1,
      perPage: 100,
      filteredObjects: [],
      filteredObjectsService: [],
      searchString: "",
      filterStatus: "all",
      selected: [], // Must be an array reference!
      selectedService: [], // Must be an array reference!
      dirtyFields: [],
      show: true,
      seen: true,
      isSaving: false,
      isSaved: false,
      dismissSecs: 3,
      dismissCountDown: 0,
      dismiss2Secs: 3,
      dismiss2CountDown: 0,
      dismiss3Secs: 3,
      dismiss3CountDown: 0,
      showDismissibleAlert: false,
      percentageOptions: {
        style: "percent",
        minimumFractionDigits: 0,
        maximumFractionDigits: 2
      },
      USDollarFormat: new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD"
      })
    };
  },
  created() {
    this.myLoadComponent();
  },
  methods: {
    formatDateRow(value, key, item) {
      const options = { year: "numeric", month: "2-digit", day: "2-digit" };
      var _retobj = new Date(value).toLocaleDateString("fr-CA", options);
      return _retobj;
    },
    rowClass(item, type) {
      if (!item || type !== "row") return;
      if (item.IsConquest) return "table-success";
      if (item.IsLostSoul) return "table-warning";
    },
    loadOtherReport(reportID) {
      if (reportID == 1) {
        this.$router.push({ name: "CampaignReport" });
      }
      if (reportID == 2) {
        this.$router.push({ name: "CampaignROI" });
      }
      if (reportID == 3) {
        this.$router.push({ name: "CampaignVisual" });
      }
    },
    back() {
      this.$router.go(-1);
    },
    as_percentage(number) {
      return new Intl.NumberFormat(undefined, this.percentageOptions).format(
        number
      );
    },
    as_dollar(number) {
      return new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD"
      }).format(number);
    },
    toggleVisibility() {
      this.seen = !this.seen;
    },
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown;
    },
    countDown2Changed(dismiss2CountDown) {
      this.dismiss2CountDown = dismiss2CountDown;
    },
    countDown3Changed(dismiss3CountDown) {
      this.dismiss3CountDown = dismiss3CountDown;
    },
    showAlert() {
      this.dismissCountDown = this.dismissSecs;
    },

    async save() {
      if (
        this.$store.state.dealer.dealers.find(
          dealer =>
            dealer.DealershipID !==
              this.$store.state.dealer.dealer_edit.DealershipID &&
            dealer.Name.toLowerCase() ===
              this.$store.state.dealer.dealer_edit.Name.toLowerCase() &&
            dealer.InternalDealerID.toLowerCase() ===
              this.$store.state.dealer.dealer_edit.InternalDealerID.toLowerCase()
        )
      ) {
        this.dismiss3CountDown = this.dismiss3Secs;
        return;
      }

      //double check the database
      // if (this.$store.state.dealer.dealer_edit.UserProfileID === -1) {
      //   var _existing_id = -1;

      //   await this.$store
      //     .dispatch(
      //       "dealer/doesDealerExist",
      //       this.$store.state.dealer.dealer_edit.Name
      //     )
      //     .then(response => {
      //       _existing_id = response.data["DoesDealerExistResult"];
      //     });

      //   if (_existing_id > -1) {
      //     this.dismiss3CountDown = this.dismiss3Secs;
      //     return;
      //   }
      // }

      this.$v.$touch();
      if (this.$v.$error) {
        this.dismiss2CountDown = this.dismiss2Secs;
      } else {
        this.$store.state.saveOp.localUrl = "/Dealer/Save/";
        this.$store.state.saveOp.localVariableName = "_d";
        this.$store.state.saveOp.localVariableObject = this.$store.state.dealer.dealer_edit;
        this.$store.state.saveOp.localDirtyFields = this.dirtyFields;
        this.$store.state.saveOp.localFieldToSet = "DealershipID";
        this.$store.state.saveOp.localReturnObject = "SaveDealerResult";

        this.$store
          .dispatch("saveOp/BuildSaveOperation")
          .then(
            this.$store
              .dispatch("saveOp/EmitSave")
              .then(
                (this.dirtyFields = []),
                (this.dismissCountDown = this.dismissSecs),
                this.$store.state.saveOp.DestroySaveOperation
              )
          );

        // this.$store
        //   .dispatch("saveOp/BuildSaveOperation")
        //   .then(this.$store.dispatch.dispatch("saveOp/EmitSave"))
        //   .then(
        //     (this.dirtyFields = [])((this.dismissCountDown = this.dismissSecs))
        //   );
      }
    },
    addDirtyField: function(event) {
      if (event.which !== 9 && event.which !== 13) {
        this.dirtyFields = this.dirtyFields.filter(
          dirtyField => dirtyField.FieldName !== event.target.id
        );
        this.dirtyFields.push({
          FieldName: event.target.id,
          FieldValue: event.target.value
        });
      }
    },
    addDirtyFieldWatch: function(field, newValue) {
      this.dirtyFields = this.dirtyFields.filter(
        dirtyField => dirtyField.FieldName !== field
      );
      this.dirtyFields.push({
        FieldName: field,
        FieldValue: newValue
      });
      this.$store.state.saveOp.localDirtyFields = this.dirtyFields;
    },
    addDirtyFieldRadio: function(event) {
      this.dirtyFields = this.dirtyFields.filter(
        dirtyField => dirtyField.FieldName !== event.target.name
      );
      this.dirtyFields.push({
        FieldName: event.target.name,
        FieldValue: event.target.value
      });
    },
    addDirtyFieldRadioWithCast: function(event) {
      this.dirtyFields = this.dirtyFields.filter(
        dirtyField => dirtyField.FieldName !== event.target.name
      );
      this.dirtyFields.push({
        FieldName: event.target.name,
        FieldValue: event.target.value
      });
      if (event.target.value == "true") {
        this.$store.state.dealer.dealer_edit.IsBoost = true;
      } else {
        this.$store.state.dealer.dealer_edit.IsBoost = false;
      }
    },
    addDirtyFieldSwitch: function(event) {
      this.dirtyFields = this.dirtyFields.filter(
        dirtyField => dirtyField.FieldName !== event.target.id
      );
      this.dirtyFields.push({
        FieldName: event.target.id,
        FieldValue: event.target.checked.toString()
      });
      this.$store.state.saveOp.localDirtyFields = this.dirtyFields;
    },
    togglePassword: function() {
      const passwordField = document.querySelector("#Password");
      if (passwordField.getAttribute("type") === "password") {
        passwordField.setAttribute("type", "text");
      } else {
        passwordField.setAttribute("type", "password");
      }
    },
    DashRouteTo(_page) {
      this.save();
      this.$router.push(_page);
    },
    async myLoadComponent() {
      await this.$store.dispatch(
        "campaign/loadCampaignROI",
        this.$store.state.campaign.campaign_report.CampaignHeader.PONumber
      );

      //}
      this.filterList();
    },
    async myRowClickHandler(record, index) {
      var _op = {
        _customer_number: record.DVCustomerNumber,
        _dealer_number: this.$store.state.campaign.campaign_roi
          .CampaignStatHeader.Dealership.InternalDealerID
      };
      await this.$store.dispatch("dealer/loadCustomerHistory", _op);
      this.$bvModal.show("modal-customer-record");
    },
    filterList: function() {
      this.filteredObjects = this.$store.state.campaign.campaign_roi.Sales;
      this.filteredObjectsService = this.$store.state.campaign.campaign_roi.ServiceROs;
      if (this.filteredObjects.length > 1) {
        this.filteredObjects = this.filteredObjects.filter(
          sale =>
            sale.FullName.toLowerCase().indexOf(
              this.searchString.toLowerCase()
            ) > -1 ||
            sale.NewUsed.toLowerCase().indexOf(
              this.searchString.toLowerCase()
            ) > -1 ||
            sale.VIN.toLowerCase().indexOf(this.searchString.toLowerCase()) >
              -1 ||
            sale.VehicleMake.toLowerCase().indexOf(
              this.searchString.toLowerCase()
            ) > -1 ||
            sale.VehicleModel.toLowerCase().indexOf(
              this.searchString.toLowerCase()
            ) > -1 ||
            sale.VehicleYear.toLowerCase().indexOf(
              this.searchString.toLowerCase()
            ) > -1
        );
      }
      if (this.filteredObjectsService.length > 1) {
        this.filteredObjectsService = this.filteredObjectsService.filter(
          service =>
            service.FullName.toLowerCase().indexOf(
              this.searchString.toLowerCase()
            ) > -1 ||
            service.VIN.toLowerCase().indexOf(this.searchString.toLowerCase()) >
              -1 ||
            service.VehicleMake.toLowerCase().indexOf(
              this.searchString.toLowerCase()
            ) > -1 ||
            service.VehicleModel.toLowerCase().indexOf(
              this.searchString.toLowerCase()
            ) > -1 ||
            service.VehicleYear.toLowerCase().indexOf(
              this.searchString.toLowerCase()
            ) > -1
        );
      }
    },
    resetSearch: function() {
      this.searchString = "";
      this.filterList();
    }
  },
  computed: {
    ...mapState(["campaign", "dealer", "n_user", "saveOp"]),
    ...mapActions("saveOp", ["Save", "EmitSave"]),
    isClean() {
      return this.dirtyFields.length === 0;
    },
    totalRows: function() {
      return this.$store.state.campaign.campaign_roi.Sales.length;
    },
    totalRowsFiltered: function() {
      return this.filteredObjects.length;
    },
    isNavVisible: function() {
      return this.totalRowsFiltered > this.perPage;
    },
    isNavVisible2: function() {
      return this.totalRowsServiceFiltered > this.perPage;
    },
    totalRowsService: function() {
      return this.$store.state.campaign.campaign_roi.ServiceROs.length;
    },
    totalRowsServiceFiltered: function() {
      return this.filteredObjectsService.length;
    },
    isNavVisibleService: function() {
      return this.totalRowsServiceFiltered > this.perPage;
    },
    showSales: function() {
      return this.filterStatus == "all" || this.filterStatus == "sales";
    },
    showService: function() {
      return this.filterStatus == "all" || this.filterStatus == "service";
    }
  },
  components: {
    cTable,
    CustomerRecordModal
  },

  watch: {}
};
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.input-group-text {
  color: #111;
}
.testred {
  color: red;
  border-color: red;
}
.my-alternating-row-color {
  background-color: rgba(32, 168, 216, 0.05) !important;
  color: #e23e25;
  padding-top: 4px;
}
.my-other-alternating-row-color {
  background-color: rgba(32, 168, 216, 0.15) !important;
  color: #e23e25;
  padding-top: 4px;
}
.btn-link:disabled,
.btn-link.disabled {
  color: #000;
  font-weight: bold;
  pointer-events: none;
  text-decoration: underline;
}
</style>
